define.alias("ember-math-helpers/helpers/pow", "preview-grid/helpers/pow");